import { Stack, StackProps } from '@mui/material'

export const StackColumn = ({ children, ...rest }: StackProps) => (
  <Stack direction="column" spacing={1} {...rest}>
    {children}
  </Stack>
)
